<template>
    <div class="container mt-nav z-index">
        <Head title="خرید بسته"/>
        <div class="row">
            <div class="col-sm-10 col-lg-6  mx-auto" v-if="orderPackage === false">
                <template v-if="userPackages.diet && userPackages.support">
                    <div class="box__information">
                        <div class="success__icon">
                            <div class="success__icon-img">
                                <img src="/front/assets/images/success.png" alt="">
                                <p class="m-0 success__icon-text">شما هم اکنون یک پکیج فعال دارید</p>
                            </div>
                        </div>
                        <template v-if="userPackages.diet">
                            <div class="text__information mt-0 mt-sm-4">
                                <div class="position-relative m-0">
                                    <p class="m-0 text-warning text-md">نام بسته رژیم</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-warning text-md">{{ userPackages.diet.title }}</p>
                                </div>
                            </div>
                            <div class="text__information mt-0 mt-sm-4">
                                <div class="position-relative m-0">
                                    <p class="m-0 text-warning text-md">تاریخ شروع</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-warning text-md">{{ userPackages.diet.start }}</p>
                                </div>
                            </div>
                            <div class="text__information mt-0 mt-sm-4">
                                <div class="position-relative m-0">
                                    <p class="m-0 text-warning text-md">تاریخ اتمام</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-warning text-md">{{ userPackages.diet.end }}</p>
                                </div>
                            </div>
                        </template>
                        <template v-if="userPackages.diet">
                            <div class="text__information mt-0 mt-sm-4">
                                <div class="position-relative m-0">
                                    <p class="m-0 text-light text-md">نام بسته پشتیبانی</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-light text-md">{{ userPackages.diet.title }}</p>
                                </div>
                            </div>
                            <div class="text__information mt-0 mt-sm-4">
                                <div class="position-relative  m-0">
                                    <p class="m-0 text-light text-md">تاریخ شروع</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-light text-md">{{ userPackages.diet.start }}</p>
                                </div>
                            </div>
                            <div class="text__information mt-0 mt-sm-4">
                                <div class="position-relative m-0">
                                    <p class="m-0 text-light text-md">تاریخ اتمام</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-light text-md">{{ userPackages.diet.end }}</p>
                                </div>
                            </div>
                            <a href="profile" class="btn btn-orange w-100-btn mt-5">بازگشت به پروفایل</a>
                            <button @click.prevent="orderNewPackage"
                                    class="btn btn-outline-orange hover_button w-100-btn mx-auto mt-5">
                                خرید بسته های جدید
                                <span class="reply me-2"></span>
                            </button>
                        </template>
                    </div>
                </template>
            </div>

            <div class="col-xl-8  mx-auto">
                <form v-if="!redirect" @submit.prevent="store">

                    <div v-if="orderPackage">
                        <div class="box__information checked-box" v-show="!status">
                            <div class="col-12 pb-5 px-0 px-sm-4">
                                <p class="text-title text-white text-center pb-3">
                                    دوره مورد نظر خود را انتخاب کنید
                                </p>
                                <div class="checked__course">
                                    <label v-for="(packageName, index) in packages" :key="packageName.id" :for="'number' + packageName.id" class="checked__course-check">
                    <span class="row">
                        <span class="col-md-8 col-xl-9 d-flex align-content-center flex-wrap flex-md-nowrap">
                            <div class="d-flex align-items-center">
                                <input class="my-auto" v-model="form.packageId" name="package" :value="packageName.id" :id="'number' + packageName.id" type="radio">
                                <p class="text-gray text-sm m-0 mx-2 my-auto white-space text-orange-check">
                                    {{ packageName.title }}
                                </p>
                            </div>
                            <p class="text-gray text-white-checked text-sm m-0 mx-3 my-auto pt-4 pt-md-0">
                                {{ packageName.description }}
                            </p>
                        </span>
                        <div class="col-md-4 col-xl-3 d-flex justify-content-end mt-5 mt-md-0">
                            <div class="box-right"></div>
                            <div class="box my-auto">
                                <div class="discount-badge">{{ packageName.discount_percent }}% تخفیف</div>
                                <p class="text-center text-dark-gray">
                                    <span class="old_price">{{ new Intl.NumberFormat().format(packageName.old_price) }}</span> -
                                    <span class="new_price">{{ new Intl.NumberFormat().format(packageName.price) }}</span>
                                </p>
                                <p class="text-center m-0 text-dark-gray">هزار تومان</p>
                            </div>
                        </div>
                    </span>
                                    </label>
                                </div>
                                <div ref="step1">
                                    <div class="text-center mt-5" v-if="form.packageId">
                                        <a href="#" @click.prevent="changeStatus()" class="btn btn-orange w-100-btn">مرحله بعد</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box__information services position-relative" :class="{ 'd-block': status !== false }" v-show="status">
                            <div v-if="form.errors.packageId" class="form-error">
                                <p class="m-0 text-sm text-error mb-3">{{ form.errors.packageId }}</p>
                            </div>
                            <div v-if="form.errors.supportPackaheId" class="form-error">
                                <p class="m-0 text-sm text-error mb-3">{{ form.errors.supportPackaheId }}</p>
                            </div>
                            <span v-if="activeDescriptionOrderPackage" @click="changeStatus()" class="btn btn-inverse-warning fs-1 position-absolute top-2 top-0 start-0 m-2">🔙</span>

                            <div class="row pb-5 px-0 px-sm-4">
                                <div class="col-md-11 mx-auto">
                                    <div class="alert alert-custom text-center mt-4 mb-4" role="alert">
                                        شما در این قسمت میتوانید بسته پشتیبان اختصاصی خود را انتخاب کنید.
                                        <br>
                                        در صورتی که به پشتیبانی اختصاصی نیازی ندارید، گزینه "نیازی به پشتیبان اختصاصی ندارم" را انتخاب کنید.
                                    </div>
                                    <div class="d-flex align-content-center justify-content-between">
                                        <div class="d-flex flex-column my-auto">
                                            <p class="text-md mb-4 text-white">خدمات سرویس حامی اختصاصی</p>
                                            <p class="text-sm text-white">تماس روزانه</p>
                                            <p class="text-sm text-white">پیگیری برنامه اجرا شده</p>
                                            <p class="text-sm text-white">ثبت اطلاعات</p>
                                        </div>
                                        <div>
                                            <img class="img-fluid" src="front/assets/images/badoom-18.png" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div class="checked__course mt-5">
                                    <label for="do_not_need" class="checked__course-check hide-box">
                    <span class="row">
                        <span class="col-md-8 col-xl-9 d-flex align-content-center flex-wrap flex-md-nowrap">
                            <div class="d-flex align-items-center">
                                <input v-model="form.supportPackaheId" class="my-auto" name="checked" value="not_need" id="do_not_need" type="radio">
                                <p class="text-gray text-sm m-0 mx-2 my-auto white-space text-orange-check">نیاز به پشتیبان ندارم</p>
                            </div>
                            <p class="text-gray text-white-checked text-sm m-0 mx-3 my-auto pt-4 pt-md-0">در صورتی که نیازی به پشتیبانی اختصاصی ندارید این گزینه را انتخاب کنید</p>
                        </span>
                        <div class="col-md-4 col-xl-3 d-flex justify-content-end mt-5 mt-md-0">
                            <div class="box-right"></div>
                            <div class="box my-auto">
                                <p class="text-center m-0 text-dark-gray">رایگان</p>
                            </div>
                        </div>
                    </span>
                                    </label>

                                    <label v-for="(packageName, index) in supportPackages" :key="packageName.id" :for="'number' + packageName.id" class="checked__course-check hide-box">
                    <span class="row">
                        <span class="col-md-8 col-xl-9 d-flex align-content-center flex-wrap flex-md-nowrap">
                            <div class="d-flex align-items-center">
                                <input v-model="form.supportPackaheId" class="my-auto" name="checked" :value="packageName.id" :id="'number' + packageName.id" type="radio">
                                <p class="text-gray text-sm m-0 mx-2 my-auto white-space text-orange-check">{{ packageName.title }}</p>
                            </div>
                            <p class="text-gray text-white-checked text-sm m-0 mx-3 my-auto pt-4 pt-md-0">{{ packageName.description }}</p>
                        </span>
                        <div class="col-md-4 col-xl-3 d-flex justify-content-end mt-5 mt-md-0">
                            <div class="box-right"></div>
                            <div class="box my-auto">
                                <div class="discount-badge">{{ packageName.discount_percent }}% تخفیف</div>
                                <p class="text-center text-dark-gray">
                                    <span class="old_price">{{ new Intl.NumberFormat().format(packageName.old_price) }}</span> -
                                    <span class="new_price">{{ new Intl.NumberFormat().format(packageName.price) }}</span>
                                </p>
                                <p class="text-center m-0 text-dark-gray">هزار تومان</p>
                            </div>
                        </div>
                    </span>
                                    </label>
                                </div>
                                <div ref="step2">
                                    <div class="text-center mt-5" v-if="form.supportPackaheId">
                                        <loading-button :loading="form.processing" class="btn border-0 btn-orange w-100-btn" type="submit">خرید و سفارش</loading-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </form>
                <div v-if="redirect" class="pt-4">
                    <div class="box__information checked-box" >
                        <p class="text-sm text-white text-center"> در حال انتقال به پروفایل. لطفا کمی منتظر بمانید
                            .</p>
                        <div class="text-sm text-white text-center">
                            <div class="spinner-grow text-danger" role="status">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {Head} from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "../Shared/Layouts/LayoutFirstRegister";
import LoadingButton from "../Shared/Layouts/LoadingButton";


export default {
    props: {
        packages: Array,
        supportPackages: Array,
        userPackages: Array,
        discount : Number
    },
    components: {
        Head, LoadingButton
    },
    created() {

        if (this.userPackages.diet && this.userPackages.support) {
            this.orderPackage = false;
        }
        if (this.userPackages.diet) {

            if (this.userPackages.support === null) {
                this.activeDescriptionOrderPackage = false;
                this.status = true;
            }
        }
    },

    data() {
        return {
            status: false,
            activeDescriptionOrderPackage: true,
            orderPackage: true,

            form: this.$inertia.form({
                packageId: false,
                supportPackaheId: true
            }),
        }

    },

    watch: {
        'form.packageId': {
            handler() {
                if (this.form.packageId) {
                    this.goto('step1');
                }
            },
            deep: true,
        },
        'form.supportPackaheId': {
            handler() {
                if (this.form.supportPackaheId) {
                    this.goto('step2');
                }
            },
            deep: true,
        }
    },

    methods: {
        orderNewPackage() {
            this.orderPackage = true;
        },
        store() {
            this.form.post('/packages')
        },
        changeStatus() {
            this.status = !this.status;
        },
        goto(refName) {
            var element = this.$refs[refName];
            var top = element.offsetTop;

            window.scrollTo(0, top);
        }
    },
    layout: LayoutFirstRegister,
    metaInfo() {
        return {
            meta: []
        }

    }
}
</script>

<style scoped>
.old_price {
    text-decoration: line-through;
    font-style: italic;
    color: #7b7b7b; /* Optional: to differentiate the old price visually */
}
.new_price {
    font-weight: bold;
    color: #ffffff; /* Optional: to highlight the new price */
}
.discount-badge {
    background-color: red;
    color: white;
    font-size: 12px;
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 10px;
    position: absolute;
    top: -34px;
    left: -10px;
}

.discount-badge::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid red;
    transform: translateX(-50%);
}
</style>
